import { useSelector, shallowEqual } from "react-redux";

const useCurrentUser = () => {
  const user = useSelector(state => state.user, shallowEqual);
  return user;
};

export default useCurrentUser;
